export const TEST_ID_SMALL_MAP = 'test-id-small-map';
export const TEST_ID_SMALL_MAP_DISCLOSURE_BUTTON =
  'test-id-small-map-disclosure-button';
